<template>
	<div>This is the single entity component
		<div v-if="entity">
			<h1>{{ entity.displayName() }}</h1>
			<pre>{{ entity }}</pre>
		</div>
		<div v-else>Nae entity ☹</div>
	</div>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmEntity",
	props: {
	},
	data () {
		return {
		};
	},
	watch: {
		id (value) {
			this.fetchEntity(value);
		}
	},
	computed: {
		...Vuex.mapState({ entity: state => state.jman.focusedEntity }),

		id () {
			return this.$route.params.id
		}
	},
	methods: {
		...Vuex.mapActions(["fetchEntity"])
	},
	created () {
		this.fetchEntity(this.id);
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Entity.vue